import * as React from 'react'
import clx from 'classnames'
import { faCalculator, FaIcon } from '@/lib/fa'

type Props = {
  title: string
  subtitle: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  onClick: () => void
  className?: string
  classNameContent?: string
}

export const GenerateBox = ({
  title,
  subtitle,
  icon: Icon,
  onClick,
  className = '',
  classNameContent = '',
}: Props) => {
  return (
    <div
      className={clx(
        'tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-rounded-2xl tw-border-2 tw-border-dashed tw-border-base-300 tw-text-content-base',
        className,
      )}
    >
      <Icon className="tw-h-10 tw-w-10" />
      <div className={classNameContent}>
        <h3 className="tw-text-center tw-text-lg tw-font-medium">{title}</h3>
        <p className="tw-text-center tw-align-middle tw-text-sm">{subtitle}</p>
      </div>

      <button
        type="button"
        onClick={() => onClick()}
        className={`tw-cursor-pointer tw-space-x-2 tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
      >
        <FaIcon icon={faCalculator} />
        <span>Generuj</span>
      </button>
    </div>
  )
}
